import { defineComponent as _defineComponent } from 'vue'
import OzBaseButton from '@@/library/v4/components/OzBaseButton.vue'
import OzDropIndicatorLine from '@@/library/v4/components/OzDropIndicatorLine.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzPlainButton, {
  OzPlainButtonColorScheme,
  OzPlainButtonSizePreset,
} from '@@/library/v4/components/OzPlainButton.vue'
import { useDraggableElement } from '@@/pragmatic-drag-and-drop/useDraggableElement'
import { useDropTargetElement } from '@@/pragmatic-drag-and-drop/useDropTargetElement'
import type { TLPageId } from 'tldraw'
import { computed, ref } from 'vue'
// const emit = defineEmits(['switch-frame', 'show-context-menu', 'move-frame-above', 'move-frame-below'])

export default /*#__PURE__*/_defineComponent({
  __name: 'WhiteboardFramePreview',
  props: {
    frameId: { default: '' },
    frameIndex: { default: 1 },
    currentFrameId: { default: '' },
    colorScheme: { default: 'light' },
    isLoadingPortraitMobileLayout: { type: Boolean, default: false },
    previewHtml: { default: '' },
    isDraggable: { type: Boolean, default: false }
  },
  emits: ["switch-frame", "show-context-menu", "move-frame-above", "move-frame-below"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'switch-frame', frameId: string): void
  (name: 'show-context-menu', event: MouseEvent, frameId: string): void
  (name: 'move-frame-above', payload: { frameId: TLPageId; targetFrameId: TLPageId }): void
  (name: 'move-frame-below', payload: { frameId: TLPageId; targetFrameId: TLPageId }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { frameId: string, frameIndex: number, currentFrameId: string | null, colorScheme: 'light' | 'dark', isLoadingPortraitMobileLayout: boolean, previewHtml: string, isDraggable: boolean };





function switchFrame(frameId: string) {
  emit('switch-frame', frameId)
}

function showContextMenu(event: MouseEvent, frameId: string) {
  emit('show-context-menu', event, frameId)
}
const itemData = computed<{ frameId: TLPageId }>(() => ({ frameId: props.frameId as TLPageId }))

/** Drag and drop */
const elementRef = ref<HTMLElement | undefined>(undefined)
const buttonRef = ref<typeof OzBaseButton | undefined>(undefined)
const { isDragging } = useDraggableElement({
  elementRef,
  type: 'whiteboard_framebar_preview',
  data: itemData,
  dragPreview: computed(() => buttonRef.value?.$el),
  dragPreviewComponentProps: ref({
    currentFrameId: null,
    xContextMenuButton: false,
  }),
  isDraggable: computed(() => props.isDraggable),
})

const { closestEdgeToPointer, addDraggableSource } = useDropTargetElement({
  elementRef,
  type: 'whiteboard_framebar_preview',
  data: itemData,
})
addDraggableSource<{ frameId: TLPageId }>({
  type: 'whiteboard_framebar_preview',
  axis: props.isLoadingPortraitMobileLayout ? 'horizontal' : 'vertical',
  axisRef: computed(() => (props.isLoadingPortraitMobileLayout ? 'horizontal' : 'vertical')),
  canDrop: () => {
    return true
  },
  onDragEnter: () => {},
  onDrop: (e) => {
    if (e.relativePositionToTarget === 'before') {
      emit('move-frame-above', { frameId: e.sourceItem.data.frameId, targetFrameId: e.targetItem.data.frameId })
    }
    if (e.relativePositionToTarget === 'after') {
      emit('move-frame-below', { frameId: e.sourceItem.data.frameId, targetFrameId: e.targetItem.data.frameId })
    }
  },
})

return { __sfc: true,emit, props, switchFrame, showContextMenu, itemData, elementRef, buttonRef, isDragging, closestEdgeToPointer, addDraggableSource, OzBaseButton, OzDropIndicatorLine, OzIcon, OzPlainButton, OzPlainButtonColorScheme, OzPlainButtonSizePreset }
}

})